import lodash from "lodash";
import { useContext } from "react";
import { EditorContext, ToolbarContext } from "./../../ricos-context";
import { DEFAULT_LINE_SPACING } from "../defaults";
const useCurrentSpacing = () => {
  const { defaultLineSpacing: defaultSpacing } = useContext(ToolbarContext);
  const { getPublicCommands } = useContext(EditorContext);
  const publicCommands = getPublicCommands();
  const currentSpacing = publicCommands.getBlockSpacing();
  return {
    ...DEFAULT_LINE_SPACING,
    ...lodash.omitBy(defaultSpacing, lodash.isNil),
    ...lodash.omitBy(currentSpacing, lodash.isNil)
  };
};
export {
  useCurrentSpacing
};
//# sourceMappingURL=get-current-selection.js.map
